import { createContext } from 'react';
const SurveyConfigContext = /*#__PURE__*/createContext(null);
export default SurveyConfigContext;